(function () {
  if (window.__susumuPostHogConsentManagerLoaded) return;
  window.__susumuPostHogConsentManagerLoaded = true;
  window.__susumuAnalyticsAllowed = false;

  var postHogLoaded = false;
  var consentFeatureLoading = false;

  function analyticsIsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(
      privacy &&
      typeof privacy.analyticsProcessingAllowed === 'function' &&
      privacy.analyticsProcessingAllowed()
    );
  }

  function announceAnalyticsReady() {
    window.__susumuAnalyticsAllowed = true;
    document.dispatchEvent(new CustomEvent('susumu:analytics-ready'));
  }

  function loadPostHog() {
    if (postHogLoaded) {
      if (window.posthog && typeof window.posthog.opt_in_capturing === 'function') {
        window.posthog.opt_in_capturing();
      }
      announceAnalyticsReady();
      return;
    }

    postHogLoaded = true;
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog&&window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="xi Si init Ni Bi pr qi Ui $i capture calculateEventProperties Zi register register_once register_for_session unregister unregister_for_session Yi getFeatureFlag getFeatureFlagPayload getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync Ki identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty Qi Wi createPersonProfile setInternalOrTestUser Ji Fi tn opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing zi debug mr it getPageViewId captureTraceFeedback captureTraceMetric Ri".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

    window.posthog.init('phc_pKS9dZXKRPB5iZ4drcavFQtj3PV96KczhMSfYuo5SaQn', {
      api_host: 'https://eu.i.posthog.com',
      defaults: '2026-05-30',
      person_profiles: 'identified_only'
    });
    announceAnalyticsReady();
  }

  function disablePostHog() {
    window.__susumuAnalyticsAllowed = false;

    if (window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
      try {
        window.posthog.opt_out_capturing({ clear_persistence: true });
      } catch (error) {
        window.posthog.opt_out_capturing();
      }
    }
  }

  function syncAnalyticsConsent() {
    if (analyticsIsAllowed()) {
      loadPostHog();
    } else {
      disablePostHog();
    }
  }

  function loadConsentFeature() {
    if (consentFeatureLoading) return;
    consentFeatureLoading = true;

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function (error) {
        consentFeatureLoading = false;
        if (!error) syncAnalyticsConsent();
      });
    } else {
      consentFeatureLoading = false;
      setTimeout(loadConsentFeature, 250);
    }
  }

  document.addEventListener('visitorConsentCollected', syncAnalyticsConsent);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadConsentFeature, { once: true });
  } else {
    loadConsentFeature();
  }
})();
